import React, { createContext, PropsWithChildren, useContext, useState, JSX } from 'react';

type IsOnProductPageContextType = {
  isOnProductPage: boolean;
  setIsOnProductPage: (isOnProductPage: boolean) => void;
};

export const IsOnProductPageContext = createContext<IsOnProductPageContextType>({
  isOnProductPage: false,
  setIsOnProductPage: () => null
});

export const IsOnProductPageProvider = ({ children }: PropsWithChildren<{}>): JSX.Element => {
  const [isOnProductPage, setIsOnProductPage] = useState<boolean>(false);

  return (
    <IsOnProductPageContext.Provider value={{ isOnProductPage, setIsOnProductPage }}>
      {children}
    </IsOnProductPageContext.Provider>
  );
};

const useIsOnProductPage = (): IsOnProductPageContextType => {
  return useContext<IsOnProductPageContextType>(IsOnProductPageContext);
};

export default useIsOnProductPage;
